module.exports = __webpack_public_path__ + "img/3@2x.08a7eda8.png";